// Tenantra Inc. - Subscription Gate Component
// Shows when user tries to access data without an active subscription
import { CreditCard, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function SubscriptionGate({ message, planRequired }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 text-center">
          {/* Icon */}
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CreditCard className="w-8 h-8 text-slate-400" />
          </div>
          
          {/* Title */}
          <h2 className="text-xl font-semibold text-slate-800 mb-2">
            Subscription Required
          </h2>
          
          {/* Message */}
          <p className="text-slate-600 mb-6">
            {message || "An active subscription is required to access your portfolio. Please subscribe to view your properties, tenants, and reports."}
          </p>
          
          {/* CTA Button */}
          <a href="/landlord/billing">
            <Button className="w-full h-11 bg-teal-600 hover:bg-teal-700 text-white font-semibold">
              View Subscription Plans
              <ChevronRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
          
          {/* Secondary Link */}
          <p className="text-sm text-slate-500 mt-4">
            Have questions?{' '}
            <a href="/landlord/dashboard" className="text-teal-600 hover:text-teal-700 font-medium">
              Return to Dashboard
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
